import * as filterActions from '../actions/filter';
import * as stallionActions from '../actions/stallion';

import { putToStorage } from '../utils/localStorageHelper';

const searchableFields = {
    stallion: null,
    sire: null,
    sireLine: null,
    studFarm: null
};

const singleFields = {
    sireFlag: null,
    sireType: 'all',
    studCountryCode: '',
    yearToStud: '',
    distance: '',
    studFee: '/'
};

const switcherFields = {
    sireLineFlag: null,
    type: 'weatherbys'
};

export const multipleFields = {
    allWeatherWinners: null,
    turfWinners: null,
    hurdleWinners: null,
    chaseWinners: null,
    g1Winner: null,
    g2Winner: null,
    g3Winner: null,
    gradeWinners: null,
    blackTypeWinners: null,
};
export const multipleFieldsStudCountryCode = {
    'GB,IRE': null,
    'GB': null,
    'IRE': null,
    'FR': null,
    'GB,IRE,FR': null,
    'USA': null,
};

export const stateHelperObj = {
    touched: true,
    rawData: {
        stallionNames: [],
        sireNames: [],
        sireLine: [],
        studFarms: []
    },
    isFetching: false
};

const dynamicFields = Object.assign({}, searchableFields, stateHelperObj);

export const filterValuesInitState = Object.assign({},
    searchableFields,
    singleFields,
    multipleFields,
    multipleFieldsStudCountryCode,
    stateHelperObj,
    switcherFields
);

export const initState = Object.assign(
    {
        isFilterVisible: false,
        isAdvancedSectionExpanded: false,
    },
    filterValuesInitState
);

export const shouldUpdate = (filterObj) => {
    const originState = Object.assign({}, searchableFields, singleFields, multipleFields, multipleFieldsStudCountryCode);

    return Object.keys(originState)
        .some((key) => originState[key] !== filterObj[key]);
};

export default function filter(state = initState, action = {}) {
    switch (action.type) {
        case filterActions.STATE_PRISTINE:
            return Object.assign({}, state, {
                isFilterVisible: false,
                touched: action.initial
            });
        case filterActions.TYPE:
            return Object.assign({}, state, dynamicFields, {
                type: action.value,
                touched: true
            });
        case filterActions.SIRE: {
            return Object.assign({}, state, {
                sire: action.value,
                touched: true
            });
        }
        case filterActions.SIRE_LINE: {
            return Object.assign({}, state, {
                sireLine: action.value,
                touched: true
            });
        }
        case filterActions.SIRE_LINE_FLAG: {
            return Object.assign({}, state, {
                sireLineFlag: action.value,
                touched: true
            });
        }
        case filterActions.STALLION: {
            return Object.assign({}, state, {
                stallion: action.value,
                touched: true
            });
        }
        case filterActions.SIRE_TYPE: {
            return Object.assign({}, state, {
                sireType: action.value,
                touched: true
            });
        }
        case filterActions.WIN_DIST: {
            return Object.assign({}, state, {
                distance: action.value,
                touched: true
            });
        }
        case filterActions.YEAR_TO_STUD: {
            return Object.assign({}, state, {
                yearToStud: action.value,
                touched: true
            });
        }
        case filterActions.COUNTRY: {
            const { value } = action;

            if (Array.isArray(value)) {
                let countries = Object.assign({}, multipleFieldsStudCountryCode);

                if (value.indexOf('all') === -1) {
                    value.forEach(v => { countries[v] = '1'; });
                }

                return Object.assign({}, state, countries, {
                    touched: true,
                    studCountryCode: value.join(',')
                });
            }
            return Object.assign({}, state, {
                [value]: state[value] ? null : '1',
                studCountryCode: state.studCountryCode.length > 0 ? `${state.studCountryCode},${value}` : value,
                touched: true
            });
        }
        case filterActions.STUD_FARM: {
            return Object.assign({}, state, {
                studFarm: action.value,
                touched: true
            });
        }
        case filterActions.STUD_FEE: {
            return Object.assign({}, state, {
                studFee: action.value,
                touched: true
            });
        }
        case filterActions.PROGENY_SUCCESS: {
            const { value } = action;
            if (Array.isArray(value)) {
                const winners = Object.assign({}, multipleFields);

                value.forEach(v => { winners[v] = '1'; });

                return Object.assign({}, state, winners, {
                    touched: true
                });
            }
            return Object.assign({}, state, {
                [value]: state[value] ? null : '1',
                touched: true
            });
        }
        case filterActions.SET_ADVANCED_SECTION: {
            const { value } = action;

            return Object.assign({}, state, {
                isAdvancedSectionExpanded: value,
                touched: true
            });
        }
        case filterActions.SET_FILTER_POPOVER: {
            const { value } = action;

            return Object.assign({}, state, {
                isFilterVisible: value,
                touched: true
            });
        }
        case filterActions.CLEAR: {
            return Object.assign({}, state, Object.assign(initState, {
                isFilterVisible: true,
                isAdvancedSectionExpanded: state.isAdvancedSectionExpanded,
            }));
        }
        case stallionActions.RAW_DATA_SUCCESS:
            putToStorage(`type-${action.filterType}`, action.payload);
            return Object.assign({}, state, {
                rawData: action.payload,
                isFetching: false,
            });
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/client/reducers/filter.js